import React from 'react';
import { StyledDivider } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
export const Divider = ({ className, 'data-testid': dataTestId, role = 'separator', 'aria-label': ariaLabel, orientation, ariaHidden, margin }) => {
    return (React.createElement(StyledDivider, { "$orientation": orientation, className: className, "data-testid": dataTestId, role: role, "aria-label": ariaLabel, "aria-orientation": orientation, "aria-hidden": ariaHidden, margin: margin }));
};
Divider.displayName = 'Divider';
//# sourceMappingURL=index.js.map